// FormData utils

'use strict';

import _ from 'lodash';

/**
 * Determine if value is a file.
 *
 * @param {mixed} value
 */
function isFile (value) {
    return value instanceof File;
}

/**
 * Make an array key.
 *
 * @param {String} key
 */
function makeArrayKey (key,count) {
    if (key.length > 2 && key.lastIndexOf('['+count+']') === key.length - 2) {
        return key;
    } else {
        return `${key}[${count}]`;
    }
}

/**
 * Convert an object to FormData.
 *
 * @param {Object} obj
 * @param {FormData|null} fd
 * @param {String|null} pre
 */
export function toFormData (obj, fd, pre,precount) {
    precount = precount || 0;
    fd = fd || new FormData();
    Object.keys(obj).forEach(prop => {
        let key = pre ? `${pre}[${prop}]` : prop;

        if (_.isObject(obj[prop]) && ! _.isArray(obj[prop]) && ! isFile(obj[prop])) {
            toFormData(obj[prop], fd, key,precount+1);
        } else if (_.isArray(obj[prop])) {
            obj[prop].forEach(value => {
                let arrayKey = makeArrayKey(key,precount);
                if (_.isObject(value) && ! isFile(value)) {
                    toFormData(value, fd, arrayKey,precount+1);
                } else {
                    fd.append(arrayKey, value);
                }
                precount++;
            });

        } else {
            fd.append(key, obj[prop]);
        }
    });

    return fd;
}